<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div>

  <div class="table-container">
    <div id="header-container" class="d-flex justify-content-end gap-3 mt-1 mb-3">
      <div class="">
        <div class="search-container">
          <input type="text" class="form-control search_input" style="font-size: 13px;" placeholder="Search"
            [(ngModel)]="searchValue">
        </div>
      </div>

      <div class="">
        <div class="d-flex gap-2 action-buttons-container">
          <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            (click)="addDocumentFunc($event)" matTooltip="Add Document">

            <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
            <span class="reload_text text-white">Add New</span>
          </div>
          <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            *ngIf="message.isAuditTrailUser" (click)="openAuditTrail('overAll',0)" matTooltip="Audit Trail">
            <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
            <span class="reload_text text-white">Audit Trail</span>
          </div>
          <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="refreshGrid()"
            matTooltip="Refresh Grid">

            <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
            <span class="reload_text">Reload</span>
          </div>

        </div>
      </div>

    </div>

    <table class="dynamic-table-container documentTable">
      <th style="min-width: 60px; text-align: center;">

      </th>
      <th *ngFor="let column of columnList"
        [ngStyle]="{'min-width': column.width, 'max-width': column.width, 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
          <span>{{column.column}}</span>
          <div class="d-flex gap-2 align-items-center">
            <div>
              <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
            </div>
          </div>

        </div>
      </th>

      <th id="menu" class="sticky-col first-col"></th>

      <tr *ngFor="let distributed of pagedItems | searchFilter : searchValue; let idx = index;">
        <td style="width: 60px; text-align: center;"
          [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
          <div style="display: flex;">
            <div [ngClass]="distributed.childCheckBoxs ?'static_icon':'hover-menu-icons'">
              <i class="fa-solid fa-ellipsis-vertical"></i>
            </div>
            <div>
              <input type="checkbox" style="zoom: 1.2;" [checked]="childCheckBoxs"
                (change)="dataGridChildCheckBoxChecked($event, distributed, idx)">
            </div>
          </div>
        </td>
        <td id="grid-row-container" style="text-align: center;overflow: hidden;text-overflow: 'ellipsis';
        white-space: 'nowrap'"><span>{{distributed.parentFolderName}}</span></td>
        <td id="grid-row-container" style="text-align: center;overflow: hidden;text-overflow: 'ellipsis';
         white-space: 'nowrap'"><span>{{distributed.parentFolderPath}}</span></td>
        <td id="grid-row-container" style="text-align: center;overflow: hidden;text-overflow: 'ellipsis';
          white-space: 'nowrap'"><span>{{distributed.allParentFolderStatus}}</span></td>
        <td id="grid-row-container" style="text-align: center;overflow: hidden;text-overflow: 'ellipsis';
           white-space: 'nowrap'"><span>{{distributed.childFolderName}}</span></td>
        <td id="grid-row-container" style="text-align: center;overflow: hidden;text-overflow: 'ellipsis';
            white-space: 'nowrap'"><span>{{distributed.childFolderPath}}</span></td>
        <td id="grid-row-container" style="text-align: center;overflow: hidden;text-overflow: 'ellipsis';
        white-space: 'nowrap'"><span>{{distributed.documentNameList}}</span></td>
        <td id="grid-row-container" style="text-align: center;overflow: hidden;text-overflow: 'ellipsis';
        white-space: 'nowrap'">
          <span>
            <div class="gridCheckBoxes">
              <img *ngIf="distributed.showHistory == 'Y'" src="../../../assets/img/accessSymbol.svg" width="20"
                height="20">
              <img *ngIf="distributed.showHistory == 'N'" src="../../../assets/img/noAcessSymbol.svg" width="20"
                height="20">
            </div>
          </span>
        </td>
        <td id="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
         white-space: 'nowrap'"><span>{{distributed.distributedReason}}</span></td>
        <td id="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
          white-space: 'nowrap'"><span>
            <div class="gridCheckBoxes">
              <img *ngIf="distributed.isActive == 'Y'" src="../../../assets/img/accessSymbol.svg" width="20"
                height="20">
              <img *ngIf="distributed.isActive == 'N'" src="../../../assets/img/noAcessSymbol.svg" width="20"
                height="20">
            </div>
          </span></td>
        <td id="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
          white-space: 'nowrap'"><span>{{distributed.createdOn | date: uiDateTimeFormat | uppercase}}</span></td>
        <td id="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
          white-space: 'nowrap'"><span>{{distributed.createdByUser}}</span></td>
        <td id="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
           white-space: 'nowrap'"><span>{{distributed.updatedOn | date: uiDateTimeFormat | uppercase}}</span></td>
        <td id="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
           white-space: 'nowrap'"><span>{{distributed.updatedByUser}}</span></td>
        <td class="sticky-col first-col">
          <div class="action-icons">
            <i class="fa-solid fa-pencil" matTooltip="Edit" style="margin-left: 5px;"
              (click)="editDocumentFunc(distributed,$event)"></i>
            <i class="fa-sharp fa-solid fa-trash" title="Delete" style="margin-left: 5px;"
              (click)="openDeletePopup(distributed,$event)"></i>
            <i class="fa-solid fa-clipboard" *ngIf="message.isAuditTrailUser" matTooltip="Audit Trail"
              style="margin-left: 5px;" (click)="openAuditTrail('individual',distributed)"></i>
          </div>
        </td>
      </tr>
    </table>
    <div class="d-flex justify-content-center">
      <div class="width-cheat small paginationCell">
        <div class="d-flex align-items-center gap-3">
          <div class="pagination_text mt-3">
            {{ showingRowsText }}
            1-{{ perPage }} of {{ collectionSize | number }}
          </div>
          <div>
            <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
              [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
              [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
            </ngb-pagination>
          </div>
          <div ngbDropdown class="mt-3">
            <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1" ngbDropdownToggle>
              {{ perPage }}
              <i class="ms-1 fa-solid fa-chevron-down"></i>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <button ngbDropdownItem (click)="paginationCall(10)">10</button>
              <button ngbDropdownItem (click)="paginationCall(20)">20</button>
              <button ngbDropdownItem (click)="paginationCall(50)">50</button>
            </div>
            per page
          </div>
        </div>
      </div>
    </div>

  </div>
  <ng-template #addOrEditDistributedPopup>
    <div class="ng-template-container">
      <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
      </div>
      <button class="close close-button" (click)="cancelAddAndEditFunction()" mat-button><i
          class="fa popupClose">&#xf00d;</i></button>


      <div mat-dialog-title>
        <label for="title" class="popupTitle"> {{title}}</label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
      </div>
      <div id="filed-container" class="form-continer"
        style="height: auto !important;max-height: 600px !important;padding-bottom: 1%;">
        <div>
          <div class="row" style="height: auto;max-height: 350px;margin-bottom: 1%;overflow-y: auto;">
            <app-folder-stucture [data]="'DISTRIBUTED'"
              (valueChange)="changeInFolderStructureChild($event)"></app-folder-stucture>
          </div>
          <fieldset class="border p-2 crFieldsetStyle">
            <div class="row">
              <div class="col-md-12">
                <div><label for="email">Reason for Distribution</label><span class="mandatory-symbol">*</span></div>
                <textarea id="distReason" class="input-filed-textarea" rows="4" type="text"
                  [(ngModel)]="distributedData.distributedReason"></textarea>
                <span id="distReason-required-msg">Please enter reason for distribution</span>
              </div>
            </div>
            <div class="row">

              <div class="col-md-3">
                <div><label for="email">Show History?</label></div>
                <mat-slide-toggle color="primary" [(ngModel)]="distributedData.showHistory1">
                  <span class="active-inActive-container" *ngIf="distributedData.showHistory1==true"
                    [ngStyle]="distributedData.showHistory1==true?{'color':'green'} : {'color': ''}">Yes</span>
                  <span *ngIf="distributedData.showHistory1==false"
                    [ngStyle]="distributedData.showHistory1==false?{'color':'red'} : {'color': ''}">No</span>
                </mat-slide-toggle>
              </div>
              <div class="col-md-3">
                <div><label for="email">Is Active?</label></div>
                <mat-slide-toggle color="primary" [(ngModel)]="distributedData.isActive1">
                  <span class="active-inActive-container" *ngIf="distributedData.isActive1==true"
                    [ngStyle]="distributedData.isActive1==true?{'color':'green'} : {'color': ''}">Active</span>
                  <span *ngIf="distributedData.isActive1==false"
                    [ngStyle]="distributedData.isActive1==false?{'color':'red'} : {'color': ''}">Inactive</span>
                </mat-slide-toggle>
              </div>
              <div class="col-md-6" *ngIf="visibleEditButton">
                <div><label for="email">Document(s)</label><span class="mandatory-symbol">*</span></div>
                <div>
                  <input type="text" class="input-filed-continers" [(ngModel)]="distributedData.documentNameList"
                    disabled>
                </div>
              </div>
            </div>

          </fieldset>

        </div>
      </div>

      <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="addOrUpdateDistributed(distributedData)" *ngIf="!visibleEditButton">
          <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
          <span class="reload_text text-white">Add New</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="addOrUpdateDistributed(distributedData)" *ngIf="visibleEditButton">
          <i class="fas fa-user-edit" style="font-size: 18px;color: white;"></i>
          <span class="reload_text text-white">Update</span>
        </div>
        <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditFunction()">
          <i class="fa fa-close"></i> Cancel
        </button>
      </div>
    </div>
  </ng-template>
  <ng-template #deleteDistributedPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{title}}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>

    <div>
      <div class="row">
        <div class="col-md-12">
          <div><label for="reason"> Reason</label><span class="mandatory-symbol">*</span></div>
          <textarea id="reason" rows="4" class="textarea-filed-continers" type="text" [(ngModel)]="reason"></textarea>
          <div id="reason-val-icon" class="field-icon-container"></div>
          <span id="reason-required-msg">Please enter reason</span>
        </div>
      </div>
    </div>
    <br>
    <div class="button-continer" mat-dialog-actions class="btn-align">
      <button mat-stroked-button class="deleteButton" (click)="deleteFunction()">
        <i class="fa fa-trash"></i> Delete
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelDeleteFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>

  </ng-template>

  <app-static-audit-trail #auditTrailPopup></app-static-audit-trail>